import { useGetShowcaseQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

export interface ShowcaseScopeArgs {
  /** Narrow the patterns to those carrying this motivation (applied only when the result is non-empty). */
  lensMotivationId?: string | null
  /** Scope to a single game (game-page views). Takes precedence over the dashboard genre filter. */
  gameId?: string | null
}

/**
 * Loads the story-pattern and motivation showcase for the active network /
 * month scope — the dashboard genre filter, or a single game when `gameId` is
 * given. A single payload drives the overview as well as the Motivation and
 * Story Pattern drill-down views.
 */
export const useUAInsightsShowcase = ({ lensMotivationId, gameId }: ShowcaseScopeArgs = {}) => {
  const { networkId, month, genreFilter } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetShowcaseQuery({
    networkId: networkId ?? undefined,
    month: month ?? undefined,
    genreId: gameId ? undefined : genreFilter ?? undefined,
    gameId: gameId ?? undefined,
    lensMotivationId: lensMotivationId ?? undefined,
  })
  return { data, isLoading: isFetching, isError, refetch }
}
